import React, { useState, useEffect } from "react";
import { employeeById, getContactDetails } from "../../../../api/employeeApi";
import LoadingSpinner from "../../../LoadingSpinner";
import { GrUserManager } from "react-icons/gr";

const VehicleStatusDriverInfo = ({ driverId, activeTab }) => {
  const [driverData, setDriverData] = useState({});
  const [contactData, setContactData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const driver = await employeeById(driverId);
      setDriverData(driver.employee);

      const contacts = await getContactDetails(9, driverId);
      setContactData(contacts.find((item) => item.conType === 1));
      setIsLoading(false);
    })();
  }, [driverId]);

  return (
    <div
      style={{
        overflowY: "auto",
        height: "66vh",
        display: activeTab === "driver" ? "flex" : "none",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "1px",
      }}
      className="basic-info"
    >
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div>
            <span>Driver</span>
            <GrUserManager size={14} style={{ marginLeft: "10px" }} />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <div>
              <div className="request-info">
                <h4 className="ui dividing header">Driver Information</h4>
                <p>
                  <span className="label">Birth date:</span>
                  <span className="value">{driverData.empBirthDate}</span>
                </p>
                <p>
                  <span className="label">Driver Code:</span>
                  <span className="value">{driverData.empCode}</span>
                </p>
                <p>
                  <span className="label">Full Name:</span>
                  <span className="value">{driverData.empFullName}</span>
                </p>
                <p>
                  <span className="label">License No:</span>
                  <span className="value">{driverData.empLicenceNumber}</span>
                </p>
                <p>
                  <span className="label">NIC Number:</span>
                  <span className="value">{driverData.empNic}</span>
                </p>
              </div>

              <div className="request-info">
                <h4 className="ui dividing header">Contact Information</h4>
                <p>
                  <span className="label">Email:</span>
                  <span className="value">{contactData?.conEmail}</span>
                </p>
                <p>
                  <span className="label">Mobile:</span>
                  <span className="value">{driverData?.empMobile}</span>
                </p>
                <p>
                  <span className="label">Address Line1:</span>
                  <span className="value">{contactData?.conAddress}</span>
                </p>
                <p>
                  <span className="label">Address Line2:</span>
                  <span className="value">{contactData?.conAddress2}</span>
                </p>
                <p>
                  <span className="label">Address Line3:</span>
                  <span className="value">{contactData?.conAddress3}</span>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleStatusDriverInfo;
